<template>
    <jc-drawer v-model="open" fullscreen class="page-drawer-wrapper">
        <div class="page-drawer">
            <div class="page-drawer-header">
                <div class="page-drawer-header-left">
                    <i @click.stop="open = false" class="jc-icon icon-arrow-left"></i>
                </div>
                <div class="page-drawer-header-right">
                    <slot name="header">
                        <div class="title" v-if="title">{{title}}</div>
                    </slot>
                </div>
            </div>
            <div class="page-drawer-body"><slot/></div>
        </div>
    </jc-drawer>
</template>

<script>
import scrollLocker from '@/utils/scroll-lock'
export default {
  name: 'page-drawer',
  props: {
    value: Boolean,
    title: String
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.open = this.value
      }
    },
    open () {
      if (!this.open) {
        scrollLocker.unlock()
        this.$emit('input', false)
      } else {
        scrollLocker.lock()
      }
    }
  },
  data () {
    return {
      open: false
    }
  }
}
</script>

<style lang="scss">
.page-drawer {
    position: relative;
    width: 100%;
    height: 100%;
    &-header {
        display: flex;
        width: 100%;
        height: 75px;
        background: #EBEAEA;
        position: absolute;
        top: 0;
        left: 0;
        overflow: hidden;
        z-index: 898;
        &-left {
            flex: 0 0 54px;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            z-index: 2;
            i {
                font-size: 32px;
                font-weight: bold;
            }
        }
        &-right {
            flex: 1;
            width: 100%;
            display: flex;
            align-items: center;
            position: relative;
            z-index: 1;
            overflow: hidden;
            .title {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 34px;
                margin-left: -54px;
                color: #606060;
            }
        }
    }
    &-body {
        position: absolute;
        top: 75px;
        left: 0;
        right: 0;
        bottom: 0;
        // width: 100%;
        // height: 100%;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        z-index: 899;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page-drawer/index.vue